import { apiClient } from './client'
import type { ApiResponse } from '../types/api'
import type { AdminRole } from '../stores/authStore'

export interface AdminPermissionsResponse {
  role: AdminRole
  /** Section → level. Validated before use — see usePermissions. */
  permissions: Record<string, unknown>
  /** Single actions that need more than the role. Missing on older APIs. */
  capabilities?: { verificationBadges?: unknown; adminControl?: unknown; supplyInsights?: unknown }
}

export const permissionsApi = {
  /** Not on production APIs older than the permission matrix (404) — callers fall back. */
  get: () => apiClient.get<ApiResponse<AdminPermissionsResponse>>('/admin/permissions'),
}
